import { BackboneMapFieldObjectWithAction } from '@ve/services/getStore/types';

export default (backboneFieldName: string): BackboneMapFieldObjectWithAction => ({
    field: backboneFieldName,
    action: (model: Backbone.Model) => model.get(backboneFieldName)?.length || 0,
});